import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { pahrumpConfig } from "./data";

export default function PahrumpPage() {
  return <OregonCityPageTemplate config={pahrumpConfig} />;
}